import * as actionTypes from "../actionTypes";

export const getCpServicesList = (data) => {
    return {
        type: actionTypes.GET_CP_SERVICES_LIST_START,
        payload: data,
    };
};
export const getCpServicesListSuccess = (data) => {
    return {
        type: actionTypes.GET_CP_SERVICES_LIST_SUCCESS,
        payload: data,
    };
};
export const getCpServicesListFailure = (data) => {
    return {
        type: actionTypes.GET_CP_SERVICES_LIST_FAILURE,
        payload: data,
    };
};

export const addCpService = (data) => {
    console.log('add cp action ')
    return {
        type: actionTypes.ADD_CP_SERVICE_START,
        payload: data,
    };
};
export const addCpServiceSuccess = (data) => {
    let d = { success: data.message}
    return {
        type: actionTypes.ADD_CP_SERVICE_SUCCESS,
        payload: d,
    };
};
export const addCpServiceFailure = (data) => {
    let d = { error: ' some error occur'}
    return {
        type: actionTypes.ADD_CP_SERVICE_FAILURE,
        payload: d,
    };
};

export const  cpServiceMessageHandler = () => {
    return {
        type: actionTypes.CP_SERVICE_MESSAGE_HANDLER,
        payload: null,
    };
};
